import { useContext, useEffect, useState } from "react";
import Container from 'react-bootstrap/Container';
import { useTranslation } from "react-i18next";
import clone from 'rfdc/default';
import { AgGridAtom, ModalAtom } from "../../../components/atoms/atom";
import { AuthContext } from "../../../contexts/AuthProvider";
import { HELP_MODES } from "../../../utils/constant";
import { getProcessStepTableColumns } from './constant';
import './process-step.scss';

function AddProcessStepModal(props) {
	const { show, onClose, onSubmit, selectedOrders = {}, processSteps = [], refresh } = props;
	const { t } = useTranslation();
	const { helpMode } = useContext(AuthContext);
	const [defaultSelectedRow, setDefaultSelectedRow] = useState(selectedOrders?.selectedProcessResourceId || []);
	const selectedProcessStep = clone(selectedOrders?.orderProcessSteps)?.reverse().find((step) => step.status > 2);
	const maxPositionTpEnable = selectedProcessStep ? selectedProcessStep.processStepPosition : -1;
	const [selectedRow, setSelectedRow] = useState([]);

	const onSaveProcessStep = () => {
		if (selectedRow.every((selRow) => selRow.resourceId)) {
			onSubmit(selectedRow);
		}
	}

	const onProcessStepResourceUpdate = (updatedSteps) => {
		setSelectedRow(updatedSteps);
	}

	const processStepColumns = getProcessStepTableColumns(t, selectedRow, maxPositionTpEnable, onProcessStepResourceUpdate);

	const onRowSelection = (selectedRows) => {
		setSelectedRow((prevSelectedRow) => {
			const selectedProcessSteps = selectedRows.map((row) => {
				// First check current selectedRow state for any recent resource changes
				const existsInCurrent = prevSelectedRow.find((obj) => obj.processStepId === row.id);
				if (existsInCurrent) {
					return existsInCurrent;
				}
				// Then check defaultSelectedRow for initial values
				const existsInDefault = defaultSelectedRow.find((obj) => obj.processStepId === row.id);
				if (existsInDefault) {
					return existsInDefault;
				}
				// New selection - create with null resourceId
				return {
					processStepId: row.id,
					resourceId: null,
					processStepPosition: row.position,
				};
			});
			return selectedProcessSteps;
		});
	}

	useEffect(() => {
		setDefaultSelectedRow(selectedOrders?.selectedProcessResourceId || []);
	}, [selectedOrders])

	useEffect(() => {
		setSelectedRow(defaultSelectedRow || []);
	}, [defaultSelectedRow])

	return (
		<ModalAtom
			title={t('modify-process')}
			titleHelpText={helpMode === HELP_MODES.ADVANCE ? t('help-advance.order-detail-process-steps') : ''}
			show={show}
			handleClose={onClose}
			refresh={refresh}
			handleSubmit={onSaveProcessStep}
			customClassName='process-step-modal'
			body={<Container>
				<AgGridAtom
					refresh={refresh}
					columnDefs={processStepColumns}
					rowData={processSteps || []}
					rowSelection={'multiple'}
					onRowSelection={onRowSelection}
				/>
			</Container>}
		/>
	);
}

export default AddProcessStepModal;
